import { Link } from "react-router-dom";

export default function GeneratorFooter() {
    return (
        <footer className="wg-footer">
            <div className="wg-footer-inner">

                <div className="wg-footer-left">
                    <strong className="wg-footer-brand">Shriansh Nexus</strong>
                    <span className="wg-footer-tagline">
                        AI-powered website generation platform
                    </span>
                </div>

                <div className="wg-footer-right">
                    <Link to="/" className="wg-footer-link">Home</Link>
                    <a href="https://shriansh.ai" target="_blank" rel="noreferrer" className="wg-footer-link">
                        Company
                    </a>
                    <a href="https://shriansh.ai/privacy" target="_blank" rel="noreferrer" className="wg-footer-link">Privacy</a>
                </div>

            </div>

            <div className="wg-footer-bottom">
                <span>© {new Date().getFullYear()} Shriansh AI</span>
            </div>
        </footer>
    );
}